export default __webpack_public_path__ + "static/media/tap_here_bottom.372a8ebd.png";